import React from 'react';
import { styled } from '../../../stitches.config';
import { observer } from 'mobx-react'
import HtmlParser from '../../../components/Article/Content/HtmlParser'
import { useStores } from '../../../helpers/useStores'

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';


const ParagraphWithImageAnimated = observer(({ blockData, ...props }) => {
    const { ArticleStore } = useStores();
    return (
        <Wrapper>
            {blockData.leftImageSrc ?
                <AnimationOnScroll duration={blockData.leftImageDuration} animateOnce={true} animateIn={blockData.leftImageDirection}>
                    <img src={blockData.leftImageSrc} />
                </AnimationOnScroll>
                :
                <SpaceFiller />
            }
            <WrapperPraser>
                <HtmlParser data={blockData.text} disableNofollow={ArticleStore.article.disableNofollowExtra} />
            </WrapperPraser>
            {blockData.rightImageSrc ?
                <AnimationOnScroll duration={blockData.rightImageDuration} animateOnce={true} animateIn={blockData.rightImageDirection}>
                    <img src={blockData.rightImageSrc} />
                </AnimationOnScroll>
                :
                <SpaceFiller />
            }
        </Wrapper>
    )
})

const Wrapper = styled("div",{
    margin: "20px 38px",
    color: "$grayscale100",
    fontSize: "16px",
    fontWeight: 400,
    letterSpacing: "0.1px",
    lineHeight: "26px",
    fontFamily: "CharsisSIL",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "img":{
        display: "none",
        "@bp5":{
            display: "block",
            width: "235px"
        },
        "@media (min-width: 1450px)":{
            width: "305px"
        }
    },
    "@bp4":{
        margin: "20px auto",
        fontSize: "21px",
        letterSpacing: "0px",
        lineHeight: "32px"
    }
});

const WrapperPraser = styled("div",{
    "@bp4": {
        width: "840px",
        margin: "0 20px",
        flexShrink: "0"
    }
});

const SpaceFiller = styled("div",{
    display: "none",
    "@bp5": {
        display: "block"
    },
    "@media (min-width: 1450px)":{
        width: "305px"
    }
});

export default ParagraphWithImageAnimated;